__turbopack_context__.v({
  "content": "CreditWarning-module-scss-module__mQYLUG__content",
  "description": "CreditWarning-module-scss-module__mQYLUG__description",
  "fade-in": "CreditWarning-module-scss-module__mQYLUG__fade-in",
  "heading": "CreditWarning-module-scss-module__mQYLUG__heading",
  "icon": "CreditWarning-module-scss-module__mQYLUG__icon",
  "no-transform": "CreditWarning-module-scss-module__mQYLUG__no-transform",
  "rotate": "CreditWarning-module-scss-module__mQYLUG__rotate",
  "wrapper": "CreditWarning-module-scss-module__mQYLUG__wrapper",
  "wrapperBoxed": "CreditWarning-module-scss-module__mQYLUG__wrapperBoxed",
});
